import { Smartphone } from 'lucide-react';
import WhatsAppConnection from './WhatsAppConnection.tsx';

const WhatsAppPage = () => (
  <div className="min-h-full bg-[#f6f7fb] px-3 py-6 text-slate-900 sm:px-6 lg:px-8">
    <div className="mx-auto w-full max-w-[1400px] space-y-5">
      <header className="mb-1 text-center max-md:pt-12">
        <h1 className="flex items-center justify-center gap-3 text-2xl font-black text-slate-900">
          <Smartphone size={28} className="text-[#2f7d72]" aria-hidden="true" />
          Conexão WhatsApp
        </h1>
        <p className="mx-auto mt-3 max-w-3xl text-sm leading-6 text-slate-600">
          Gerencie o número e a conexão do telefone usado pelo AtendaBot.
        </p>
      </header>
      <WhatsAppConnection standalone />
    </div>
  </div>
);

export default WhatsAppPage;
